import { useEffect, useState, useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import axios from "axios"
import {
  CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from "@/components/ui/command"
import { API_BASE } from "@/config/api"

const API = API_BASE

export function CommandPalette({ open, onOpenChange }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [q, setQ] = useState("")
  const [results, setResults] = useState({ clients: [], notes: [] })

  useEffect(() => {
    const down = (e) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault()
        onOpenChange(!open)
      }
    }
    document.addEventListener("keydown", down)
    return () => document.removeEventListener("keydown", down)
  }, [open, onOpenChange])

  const search = useCallback(async (query) => {
    if (!query.trim()) {
      setResults({ clients: [], notes: [] })
      return
    }
    try {
      const { data } = await axios.get(`${API}/search`, { params: { q: query } })
      setResults(data)
    } catch {
      setResults({ clients: [], notes: [] })
    }
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => search(q), 200)
    return () => clearTimeout(timer)
  }, [q, search])

  const go = (path) => {
    onOpenChange(false)
    navigate(path)
  }

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder={t("app.commandPalette.placeholder")} value={q} onValueChange={setQ} />
      <CommandList>
        <CommandEmpty>{t("app.commandPalette.empty")}</CommandEmpty>
        <CommandGroup heading={t("app.commandPalette.quickActions")}>
          <CommandItem onSelect={() => go("/app/appointments?action=new")}>{t("app.commandPalette.newAppointment")}</CommandItem>
          <CommandItem onSelect={() => go("/app/notes?action=new")}>{t("app.commandPalette.newNote")}</CommandItem>
          <CommandItem onSelect={() => go("/app/billing?action=new")}>{t("app.commandPalette.newInvoice")}</CommandItem>
          <CommandItem onSelect={() => go("/app/clients?action=new")}>{t("app.commandPalette.newClient")}</CommandItem>
          <CommandItem onSelect={() => go("/app/care-plans")}>{t("app.commandPalette.carePlans")}</CommandItem>
        </CommandGroup>
        {results.clients?.length > 0 && (
          <CommandGroup heading={t("app.commandPalette.clients")}>
            {results.clients.map((c) => (
              <CommandItem key={c.id} onSelect={() => go(`/app/clients?open=${c.id}`)}>
                {c.name} — {c.email}
              </CommandItem>
            ))}
          </CommandGroup>
        )}
        {results.notes?.length > 0 && (
          <CommandGroup heading={t("app.commandPalette.notes")}>
            {results.notes.map((n) => (
              <CommandItem key={n.id} onSelect={() => go(`/app/notes?note=${n.id}`)}>
                {n.client_name}: {n.preview}
              </CommandItem>
            ))}
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  )
}
